export const GET_DRAWER_ORDERS_REQUEST = 'GET_DRAWER_ORDERS_REQUEST';
export const getDrawerOrders = () => ({
  type: GET_DRAWER_ORDERS_REQUEST,
});

export const GET_DRAWER_ORDERS_SUCCESS = 'GET_DRAWER_ORDERS_SUCCESS';
export const getDrawerOrdersSuccess = () => ({
  type: GET_DRAWER_ORDERS_SUCCESS,
});

export const GET_DRAWER_ORDERS_FAILURE = 'GET_DRAWER_ORDERS_FAILURE';
export const getDrawerOrdersFailure = (error) => {
  return {
    type: GET_DRAWER_ORDERS_FAILURE,
    error,
  };
};

export const CLEAR_DRAWER_ORDERS = 'CLEAR_DRAWER_ORDERS';
export const clearDrawerOrders = () => ({
  type: CLEAR_DRAWER_ORDERS,
});

export const VALIDATE_DRAWER_ADDRESS_REQUEST = 'VALIDATE_DRAWER_ADDRESS_REQUEST';
export const validateAddressRequest = (addresses) => {
  return {
    type: VALIDATE_DRAWER_ADDRESS_REQUEST,
    addresses,
  };
};

export const VALIDATE_DRAWER_ADDRESS_SUCCESS = 'VALIDATE_DRAWER_ADDRESS_SUCCESS';
export const validateAddressSuccess = (fulfillmentPlanIds) => {
  return {
    type: VALIDATE_DRAWER_ADDRESS_SUCCESS,
    fulfillmentPlanIds,
  };
};

export const VALIDATE_DRAWER_ADDRESS_FAILURE = 'VALIDATE_DRAWER_ADDRESS_FAILURE';
export const validateAddressFailure = (address) => {
  return {
    type: VALIDATE_DRAWER_ADDRESS_FAILURE,
    address,
  };
};

export const SET_SECTION_STATE = 'SET_SECTION_STATE';
export const setSectionState = (sectionId, sectionState) => {
  return {
    type: SET_SECTION_STATE,
    sectionId,
    sectionState,
  };
};

export const REORDER_SINGLE_SELECTION_DRAWER_MODULES = 'REORDER_SINGLE_SELECTION_DRAWER_MODULES';
export const reorderSingleSelectionDrawerModules = (newOrderOfModules) => ({
  type: REORDER_SINGLE_SELECTION_DRAWER_MODULES,
  newOrderOfModules,
});

export const REORDER_MULTI_SELECTION_DRAWER_MODULES = 'REORDER_MULTI_SELECTION_DRAWER_MODULES';
export const reorderMultiSelectionDrawerModules = (newOrderOfModules) => ({
  type: REORDER_MULTI_SELECTION_DRAWER_MODULES,
  newOrderOfModules,
});

export const BULK_APPLY_RECOMMENDATIONS = 'BULK_APPLY_RECOMMENDATIONS';
export const bulkApplyRecommendations = (bulkUpdateJobGuid, isRateShopperRecommendationsEnabled) => ({
  type: BULK_APPLY_RECOMMENDATIONS,
  bulkUpdateJobGuid,
  isRateShopperRecommendationsEnabled,
});

export const BULK_APPLY_RECOMMENDATIONS_SUCCESS = 'BULK_APPLY_RECOMMENDATIONS_SUCCESS';
export const bulkApplyRecommendationsSuccess = ({ bulkUpdateJobGuid, amountSaved }) => ({
  type: BULK_APPLY_RECOMMENDATIONS_SUCCESS,
  bulkUpdateJobGuid,
  amountSaved,
});
